import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import JoditEditor from "jodit-react";
import Adminnavbar from "../Adminnavbar";

export default function EditJob() {
    const editor = useRef(null);
    const { id } = useParams();
    const [loader, setLoader] = useState(false);
    const [job, setJob] = useState({
        title: "",
        category: "",
        time: "",
        experience: "",
        department: "",
        description: "",
    });

    const navigate = useNavigate();

    useEffect(() => {
        const getJobData = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_BASE_URL}/job/${id}`
                );
                if (res.status === 200) {
                    setJob(res.data.data);
                } else {
                    setJob([]);
                }
            } catch (err) {
                console.log(err);
                setLoader(true);
            }
        };

        getJobData();
    }, [id]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setJob({ ...job, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // VALIDATIONS
        if (!job.title.trim() || !job.description.trim()) {
            Swal.fire({
                title: "Please enter all fields",
                icon: "warning",
            });
            return;
        }

        try {
            const res = await axios.put(`${process.env.REACT_APP_BACKEND_BASE_URL}/job/update/${id}`, job);

            if (res.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Job Update Successfully",
                    timer: 1500,
                }).then(() => navigate("/job-list"));
            } else {
                Swal.fire({
                    title: "Job Update Failed",
                    icon: "error",
                });
            }
        } catch (err) {
            console.error(err);
            Swal.fire({
                title: "Something went wrong!",
                icon: "error",
            });
        }
    };

    return (
        <>
            <Adminnavbar />
            {loader || (
                <div className="page-wrapper">
                    <div className="content">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <nav
                                    aria-label="breadcrumb"
                                    style={{ "--bs-breadcrumb-divider": "none" }}
                                >
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/admindashbord">Dashboard </Link> /
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/job-list">Jobs </Link> /
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Edit Job
                                        </li>
                                    </ol>
                                </nav>

                                <div className="col-lg-12 col-sm-12">
                                    <div className="content-page-header">
                                        <h5>Edit Job</h5>
                                    </div>

                                    <div className="row">
                                        {/* Title */}
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label>Title</label>
                                                <input
                                                    type="text"
                                                    name="title"
                                                    className="form-control"
                                                    placeholder="Enter Title"
                                                    value={job.title}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        {/* Category */}
                                        <div className="col-lg-4">
                                            <label>Category</label>
                                            <select
                                                name="category"
                                                className="form-control"
                                                value={job.category}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select</option>
                                                <option value="Article Assistant">Article Assistant</option>
                                                <option value="Qualified CA">Qualified CA</option>
                                                <option value="Semi-qualified">Semi-qualified</option>
                                                <option value="Support Roles">Support Roles</option>
                                                <option value="Others">Others</option>
                                            </select>
                                        </div>

                                        <div className="col-lg-4">
                                            <label>Job Type</label>
                                            <select
                                                name="time"
                                                className="form-control"
                                                value={job.time}
                                                onChange={handleInputChange}
                                            >
                                                <option value="">Select</option>
                                                <option value="Full Time">Full Time</option>
                                                <option value="Part Time">Part Time</option>
                                                <option value="Internship">Internship</option>
                                            </select>
                                        </div>

                                        {/* Experience */}
                                        <div className="col-lg-4 mt-3">
                                            <label>Experience</label>
                                            <input
                                                type="text"
                                                name="experience"
                                                className="form-control"
                                                placeholder="e.g. 1-3 Years"
                                                value={job.experience}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        {/* Department */}
                                        <div className="col-lg-4 mt-3">
                                            <label>Department</label>
                                            <input
                                                type="text"
                                                name="department"
                                                className="form-control"
                                                value={job.department}
                                                onChange={handleInputChange}
                                            />
                                        </div>

                                        {/* Description (Jodit) */}
                                        <div className="col-lg-12 mt-3">
                                            <label>Description</label>
                                            <JoditEditor
                                                ref={editor}
                                                value={job.description}
                                                onChange={(newContent) =>
                                                    setJob((prev) => ({
                                                        ...prev,
                                                        description: newContent,
                                                    }))
                                                }
                                            />
                                        </div>


                                        {/* Buttons */}
                                        <div className="col-lg-12 mt-4">
                                            <div className="btn-path">
                                                <Link to={"/job-list"} className="btn btn-cancel me-3">
                                                    Back
                                                </Link>
                                                <button type="submit" className="btn btn-submit">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}
